// todo: [4183561] should update to use palette provided by theme provider
export const palette = {
  neutralLight: '#edebe9',
  neutralLighter: '#f3f2f1',
  neutralPrimary: '#323130',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralSecondary: '#605e5c',
  neutralSecondaryAlt: '#8a8886',
  neutralTertiary: '#a19f9d',
  themeDark: '#005a9e',
  themeDarkAlt: '#106ebe',
  themeDarker: '#004578',
  themePrimary: '#0078d4',
  white: '#ffffff',
};
